/**
 * Query to determine if a Classroom is a Clever Library class
 */
import * as React from "react";

import type {AsyncApolloQueryResult} from "@khan/data-gql-apollo";

import ApolloQuery from "~/data-access/gql/apollo-query.tsx";

import type {getIsClassCleverLibrarySyncedType} from "./__graphql-types__/index.ts";
import {GET_IS_CLASS_CLEVER_LIBRARY_SYNCED_QUERY} from "./get-is-class-clever-library-synced.ts";

interface Props {
    classDescriptor?: string | null | undefined;
    children: (result: QueryResult) => React.ReactNode;
}

export interface QueryResult {
    error?: Error;
    isLoading: boolean;
    isCleverLibraryClass: boolean;
}

export type QueryResponse = AsyncApolloQueryResult<
    getIsClassCleverLibrarySyncedType["response"],
    getIsClassCleverLibrarySyncedType["variables"]
>;

const mapDataToResult = ({
    data,
    loading,
    error,
}: QueryResponse): QueryResult => {
    return {
        error,
        isLoading: loading,
        isCleverLibraryClass: !!(
            data &&
            data.classroom &&
            data.classroom.isCleverLibrarySynced
        ),
    };
};

export default function CleverLibraryClassQuery({
    classDescriptor,
    children,
}: Props) {
    if (!classDescriptor) {
        return children({isCleverLibraryClass: false, isLoading: false});
    }

    return (
        <ApolloQuery
            query={GET_IS_CLASS_CLEVER_LIBRARY_SYNCED_QUERY}
            variables={{classDescriptor}}
            fetchPolicy="cache-first"
        >
            {(result) => children(mapDataToResult(result))}
        </ApolloQuery>
    );
}
